import React, { useEffect, useState } from 'react'
import { useLocation } from "react-router-dom";
import SystemDisp from './SystemDisp';
import calcProfitAm from '../../../utils/systems/calcProfit';
import { useNavigate } from "react-router-dom";
import AuthProtected from '../../HOCs/AuthProtected';
import { useFollowSystemMutation, useDeleteSystemMutation, usePublishSystemMutation } from '../../../services/api/systemsApi';
import { useGetUserSessionQuery } from '../../../services/api/userApi';

const System = () => {
    const { data: userSessionData, isLoading: isUserSessionLoading, isError: isUserSessionError, isFetching: isUserSessionFetching } = useGetUserSessionQuery();
    const isSubActive = userSessionData?.isSubActive?.isActive;
    const navigate = useNavigate();
    const location = useLocation();
    const [system, setSystem] = useState(() => {
        return location.state ? location.state.system : null;
    });
    const [sysType, setSysType] = useState(() => {
        return location.state ? location.state.sysType : null;
    });
    const editPath = "/system-builder";
    const [sznWL, setSznWL] = useState([]);
    const [profit, setProfit] = useState(0);
    const [pubRes, setPubRes] = useState("");
    const [modalStep, setModalStep] = useState('submission');

    // RTK Mutations
    const [followSystem, { isLoading: isFollowSystemLoading, isError: isFollowSystemError }] = useFollowSystemMutation();
    const [deleteSystem, { isLoading: isDeleteSystemLoading, isError: isDeleteSystemError }] = useDeleteSystemMutation();
    const [publishSystem, { isLoading: isPublishSystemLoading, isError: isPublishSystemError }] = usePublishSystemMutation();

    // run on mount - if location is not set navigate to systems page
    useEffect(() => {
        if (!location.state) {
          navigate('/systems', { replace: true });
        }
    }, [location, navigate]);
    
    // run when system is set, get sznWL data for charts, get edit path 
    useEffect(()=>{
        if(system && Object.keys(system).length > 0){        
            // hold win percentage data yr over yr
            let seasons = Object.keys(system.matches);
            let units = 1, total_prof = 0;
            // tmp sznWL arr
            let tmpSznWL = [];
            for(const szn of seasons){
                let games = system.matches[szn];
                // season win loss and push count
                let sznW = 0, sznL = 0, sznP = 0, sznProf = 0;
                if(games.length > 0){
                    for(const game of games){
                        let betProf;
                        if(game.bet.result === "W"){
                            sznW = sznW+1;
                            betProf = calcProfitAm(game.bet.odds, units);
                            sznProf = sznProf + betProf;
                            total_prof = total_prof + betProf;
                        }else if(game.bet.result === "L"){
                            sznL = sznL+1;
                            sznProf = sznProf - units;
                            total_prof = total_prof - units;
                        }else if(game.bet.result === "P"){
                            sznP = sznP+1;
                        };
                    };
                };
                tmpSznWL.push({season: szn, w: sznW, l:sznL, p:sznP, prof:sznProf.toFixed(2)});
            };
            setSznWL(tmpSznWL);
            setProfit(total_prof.toFixed(2));
        }
    },[system]);

    // function to handle system being followed 
    const handleSystemFollow = async() =>{
        if(!isSubActive){
            return;
        }
        try{
            const system_id = system?._id.toString() || '';
            const response = await followSystem({ system_id, sport:system.sport }).unwrap();
            // if follow is successful, change sysType to followed - then update users followed systems
            if(response.acknowledged){
                setSysType("followed");
            };
        }catch(error){
            console.error('Error following system:', error);
        }
    };

    // function to delete system from database and any unsettled matches 
    const handleDeleteSystem = async() =>{
        try{
            const system_id = system._id.toString() || '';
            const response = await deleteSystem(system_id).unwrap();
            // if deleted - remove system from private systems and navigate to systems page
            if(response === "System deleted successfully"){
                navigate('/systems');
            };
        }catch(error){
            console.error('Error deleting system:', error);
        }
    };
    
    // Function to handle function publishing
    const handlePublishSystem = async() => {
        if(!isSubActive){
            return;
        }
        try{
            const response = await publishSystem(system._id).unwrap();
            setPubRes(response);
            setModalStep('response');
            setSysType("followed");
        }catch(error){
            console.error('Error publishing system:', error);
        }
    };

    // function to edit system
    const editSystem = () => {
        navigate(editPath, {state:{system:system, pageType:"edit", sznWL:sznWL}});
    };

    if(system != {}){
        return(
            <SystemDisp system={system} 
                sznWL={sznWL} 
                pageType="existing" 
                sysType={sysType} 
                publishSystem={handlePublishSystem}
                deleteSystem={handleDeleteSystem}
                handleSystemFollow={handleSystemFollow}
                editSystem={editSystem}
                modalStep={modalStep}
                setModalStep={setModalStep}
                pubRes={pubRes}
                isSubActive={isSubActive}
            />
        )
    }else{
        return(<></>)
    }

}

export default AuthProtected(System);